import { onReady } from "../../utils/events/onReady";
import Swiper from "../../../node_modules/swiper/swiper-bundle.js";

export class Cards {
    data = {};
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }

    init() {
        const breakpoint = window.matchMedia("(min-width: 992px)");

        let cardSwiper = [];

        const createLayout = function () {
            // if larger viewport and grid layout needed
            if (breakpoint.matches === true) {
                // clean up old instances and inline styles when available
                if (cardSwiper.length > 0) {
                    cardSwiper.forEach(swiperInstance => {
                        // Destroy with both parameters set to true to remove all styles and instance
                        swiperInstance.destroy(true, true);
                        // Remove the swiper container from DOM
                        if (swiperInstance.el && swiperInstance.el.parentNode) {
                            swiperInstance.el.parentNode.removeChild(swiperInstance.el);
                        }
                    });
                    cardSwiper = [];
                }
            } else if (breakpoint.matches === false) {
                // fire small viewport version of swiper
                if (cardSwiper.length > 0) {
                    cardSwiper.forEach(swiperInstance => {
                        // Destroy with both parameters set to true to remove all styles and instance
                        swiperInstance.destroy(true, true);
                        // Remove the swiper container from DOM
                        if (swiperInstance.el && swiperInstance.el.parentNode) {
                            swiperInstance.el.parentNode.removeChild(swiperInstance.el);
                        }
                    });
                    cardSwiper = [];
                }
                cardSwiper.push(createSwiper());
            }
        };

        const createSwiper = function () {
            return new Swiper(".card-swiper", {
                loop: false,
                slidesPerView: 1.1,
                centeredSlides: true,
                centeredSlidesBounds: true,
                spaceBetween: 20,
                effect: "slide",
                a11y: true,
                keyboardControl: true,
                grabCursor: true,
                speed: 600,
                pagination: {
                    el: ".swiper-pagination-cards",
                    type: "bullets",
                    clickable: true
                },
                breakpoints: {
                    480: {
                        slidesPerView: 1.2,
                        spaceBetween: 10
                    },
                    640: {
                        slidesPerView: 1.6,
                        spaceBetween: 10
                    },
                    768: {
                        slidesPerView: 2.6,
                        spaceBetween: 16
                    }
                }
            });
        };
        breakpoint.addListener(createLayout);
        createLayout();
    }
}
